import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const BoxWrapper = ({ children, ...props }) => (
  <BoxWrapperStyled {...props}>{children}</BoxWrapperStyled>
);

export default BoxWrapper;

const BoxWrapperStyled = styled(Box).attrs(({ $fullWidth }) => ({
  width: { _: '100%', m: $fullWidth ? '100%' : '50%' },
}))`
  > * {
    width: 100%;
  }

  @media (min-width: 768px) {
    &:nth-child(even) {
      padding-left: ${({ theme, $fullWidth }) =>
        $fullWidth ? 0 : theme.space[2]}px;
    }
    &:nth-child(odd) {
      padding-right: ${({ theme, $fullWidth }) =>
        $fullWidth ? 0 : theme.space[2]}px;
    }
  }
`;
